import React from 'react';

import ReactDOM from 'react-dom';

import NavBar from './NavBar';

import Pokaz_zestawienie from './Pokaz_zestawienie';

import Lista from './Lista';

import swal from 'sweetalert';

import axios from 'axios';

import Select from 'react-select';

import './index.css';

import apiurl from './apiurl';

import Lista_zestawienia from './Lista_zestawienia.js';

import MySelect from "./MySelect.js";







export default class Gen_zestawienie extends React.Component {

  constructor(props) {

    super(props);    

    this.state = {

    token : props.token,

    rok: props.rok,

    username: props.username,

    id: props.id,

    kodoper: props.kodoper,

    nazwastrony: "Gen_zestawienie",

    rozdzial: '',

    selectedOption3: [],

    selectedOption4: [],

    data3: [],

    data4: [],

    items3: [],

    items4: [],

    check1: false,

    check2: false,

    check3: false,

    check4: true,

    stalytekst: props.stalytekst,

  }

  this.checkboxvalue1 = this.checkboxvalue1.bind(this);

  this.checkboxvalue2 = this.checkboxvalue2.bind(this);

  this.checkboxvalue3 = this.checkboxvalue3.bind(this);

  this.checkboxvalue4 = this.checkboxvalue4.bind(this);

  this.checkboxvalue5 = this.checkboxvalue5.bind(this);



  }



componentWillMount(){

  ReactDOM.render(<NavBar token = {this.state.token} id = {this.state.id} rok = {this.state.rok} nazwastrony = {this.state.nazwastrony} username = {this.state.username} kodoper = {this.state.kodoper} />, document.getElementById("header")); 

}

componentDidMount(){

  if(this.state.id === null){

    ReactDOM.render(<Lista token = {this.state.token} id = {this.state.id} rok = {this.state.rok} nazwastrony = {this.state.nazwastrony} username = {this.state.username} kodoper = {this.state.kodoper} />, document.getElementById("root"));

  } else { this.onLista() }



  if(this.props.text1w) {

    let jedent = this.props.text1w;

    let jedenv = this.props.value1w;

    let dwat = this.props.text2w;

    let dwav = this.props.value2w;

    let sel3 = this.props.selectedOption3w;

    let sel4 = this.props.selectedOption4w;

    let che1w = this.props.check1w;

    let che2w = this.props.check2w;

    let che3w = this.props.check3w;



    this.setState({value1: jedenv, text1: jedent, value2: dwav, text2: dwat, selectedOption3: sel3, selectedOption4: sel4, check1: che1w, check2: che2w, check3: che3w})

  }

  if(sessionStorage.getItem('czyuwagi')) {
    let czytrue = sessionStorage.getItem('czyuwagi').toString() === 'true';
    this.setState({ check5 : czytrue });
  } else {
    sessionStorage.setItem("czyuwagi", false);
  }


}







onLista = async () => {

  const res = await axios.get(apiurl+"api/Raporty?", { params : {rok : this.state.rok, idUchwaly: this.state.id  }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));

  let data1 = res.data.grupaZestawien.map( category1 => ({ value: category1.value, label: category1.text}));

  let data2 = res.data.zestawienie.map( category2 => ({ value: category2.value, label: category2.text}));

  let data3 = res.data.rodzaj.map( category3 => ({ value: category3.value, label: category3.text}));

  let data4 = res.data.wydzialy.map( category4 => ({ value: category4.value, label: category4.text}));

  if(this.props.text1w) { this.setState({data1, data2, data3, data4 }) }

  else { this.setState({data1, data2, data3, data4, value1: data1[1].value, text1: data1[1].label, value2: data2[0].value, text2: data2[0].label }) }

}



pokaz = (zapisz) => {

zapisz.preventDefault();

if(this.state.items3.length > 0){

  if(this.state.items4.length > 0){ReactDOM.render(<Pokaz_zestawienie wydzialytext={this.state.selectedOption4} text1={this.state.text1} text2={this.state.text2} token = {this.state.token} uchwala={this.props.uchwala} id = {this.state.id} rok = {this.state.rok} username = {this.state.username} grupaZestawienValue = {this.state.value1} grupaZestawienValuetext = {this.state.text1} zestawienieValue = {this.state.value2} rodzajValues = {this.state.items3} wydzialyValues = {this.state.items4} zZadaniami = {this.state.check1} pominStanyZerowe = {this.state.check2} pominOpisy = {this.state.check3} kwotyWniosku = {this.state.check4} sel3={this.state.selectedOption3} sel4={this.state.selectedOption4} check1w={this.state.check1} check2w={this.state.check2} check3w={this.state.check3} stalytekst={this.state.stalytekst} rozdzial={this.state.rozdzial} czyuwagicheck={this.state.check5} />, document.getElementById("root"))}

  else { swal("Wybierz wydziały.")}  

}else { swal("Wybierz rodzaje.")}

}









wybrane3 = (selectedOption3) => { this.setState({ selectedOption3 }) };

wybrane4 = (selectedOption4) => { this.setState({ selectedOption4 }) };



checkboxvalue1() {this.setState(state => ({ check1: !state.check1 }))};

checkboxvalue2() {this.setState(state => ({ check2: !state.check2 }))};

checkboxvalue3() {this.setState(state => ({ check3: !state.check3 }))}

checkboxvalue4() {this.setState(state => ({ check4: !state.check4 }))}

checkboxvalue5(e) {
  this.setState({ check5: e.target.checked });
  sessionStorage.setItem('czyuwagi', e.target.checked)
}



polacz(zapisz) {

  let {items3, selectedOption3, items4, selectedOption4} = this.state;

  selectedOption3.map(item3 => { items3.push(item3.value) });

  selectedOption4.map(item4 => { items4.push(item4.value) });

  this.pokaz(zapisz); 

}



onChange = (a) => {

  this.setState({ [a.target.name]: a.target.value });

}







render() {

const { data1, data2, data3, data4, text1, text2, check1, check2, value2, check3, check4, check5 } = this.state;



return (

<React.Fragment>

<div class="container-fluid">

<h1>Generuj zestawienie</h1>

<p>{this.props.uchwala}</p>

<hr />

    <form id="function" name="form" class="form-horizontal" onSubmit={(zapisz) => this.polacz(zapisz)} > 

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Grupa zestawień:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  <Select name="form-field-name1" options={data1} placeholder={text1} onChange={a => this.setState({value1: a.value, text1: a.label})}  />

                  </div>

          </div><br></br>

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Zestawienie:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  <Select name="form-field-name2" options={data2}  placeholder={text2} onChange={a => (this.setState({value2: a.value, text2: a.label}) ) } />

                  </div>

          </div><br></br>

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Rodzaj:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  <MySelect

                  options={data3}

                  placeholder ="Wybierz..."

                  isMulti

                  closeMenuOnSelect={false}

                  hideSelectedOptions={false}

                  onChange={this.wybrane3}

                  allowSelectAll={true}

                  value={this.state.selectedOption3}

                  />

                  </div>

          </div> <br></br>

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Wydziały:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  <MySelect

                  options={data4}

                  placeholder ="Wybierz..."

                  isMulti

                  closeMenuOnSelect={false}

                  hideSelectedOptions={false}

                  onChange={this.wybrane4}

                  allowSelectAll={true}

                  value={this.state.selectedOption4}

                  />

                  </div>

          </div> <br></br>

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Stały tekst na wydruku:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  {value2 === '1' || value2 === '4' ? (<input type="text" class="form-control" disabled></input>) : (<input type="text" class="form-control" value={this.state.stalytekst} id="stalytekst" name="stalytekst"  onChange={this.onChange.bind(this)} ></input>)}

                  </div>

          </div><br></br>

          <div class="row">

                <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Rozdział:</label></div>

                <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                <input type="number" length="5" class="form-control" value={this.state.rozdzial} id="rozdzial" name="rozdzial"  onChange={this.onChange.bind(this)} ></input>

                </div>

          </div><br></br>

          <div class="row">

                <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Z zadaniami:</label></div>

                <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                {value2 === '3' || value2 === '4' ? (<>

                {value2 === '4' ? (<input type="checkbox" checked={true} disabled></input>) : (<input type="checkbox" checked={check1} disabled></input>)}

                </>) : (<input type="checkbox" checked={check1} onClick={this.checkboxvalue1}></input>)}

                </div>

          </div><br></br>

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Pomiń stany zerowe:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  {value2 === '3' || value2 === '4' ? (<>

                  {value2 === '4' ? (<input type="checkbox" checked={true} disabled></input>) : (<input type="checkbox" checked={check2} disabled></input>)}

                  </>) : (<input type="checkbox" checked={check2} onClick={this.checkboxvalue2}></input>)}

                  </div>

          </div> <br></br>

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Pomiń opisy/uwagi:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  {value2 === '1' ? (<input type="checkbox" checked={check3} disabled></input>) : (<input type="checkbox" checked={check3} onClick={this.checkboxvalue3}></input>)}

                  </div>

          </div> <br></br>

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Kwoty wniosku:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  {value2 === '4' ? (<input type="checkbox" checked={check4} onClick={this.checkboxvalue4}></input>) : (<input type="checkbox" checked={check4} disabled></input>)}

                  </div>

          </div> <br></br>

          
          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Pokaż uwagi w planie:</label></div>

                  <div class="col-xs-5 col-sm-5 col-md-3 col-lg-3">

                  <input type="checkbox" checked={check5} onClick={(e) => (this.checkboxvalue5(e))}></input>

                  </div>

          </div> <br></br>

          <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"></div>

                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button type="button"  class="btn btn-light pull-left"  onClick={() => ReactDOM.render(<Lista_zestawienia token = {this.state.token} username = {this.state.username}  kodoper={this.state.kodoper} rok={this.state.rok}/>, document.getElementById("root"))} >Wróć</button></div>

                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">

                  <button type="submit"  class="btn btn-light pull-left" id="function" >Generuj</button>

                  </div>

          </div>

      </form>

  </div>

  </React.Fragment>

      );

    }

  }



